/**
 * Synced from `.local/gemini-cli/packages/cli/package.json`.
 * Update with: `npm run update:gemini-cli-version`
 */
export const GEMINI_CLI_VERSION = "0.42.0-nightly.20260428.g59b2dea0e";
